<template>
  <div class="standalone-auth">
    <div class="standalone-auth__card">
      <LogoTile v-if="logoUrl" :src="logoUrl" :alt="tenantName" :size="48" />
      <v-icon color="warning" size="32">cloud_off</v-icon>
      <h1 class="standalone-auth__title">{{ tenantName }}</h1>
      <p class="standalone-auth__message">{{ message }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useTheme } from "vuetify";
import { useSessionStore } from "@/stores/session";
import LogoTile from "@/shell/LogoTile.vue";

export default defineComponent({
  name: "Unavailable",
  components: { LogoTile },
  setup() {
    const session = useSessionStore();
    const theme = useTheme();
    const found = computed(() => !!session.tenant?.found);
    const tenantName = computed(() => (found.value ? session.tenant?.name || "This app" : "MetaShip"));
    const logoUrl = computed(() => {
      const branding = session.tenant?.branding;
      if (!branding) return null;
      return (theme.global.current.value.dark ? branding.logoDarkUrl : branding.logoLightUrl) || null;
    });
    const message = computed(() => {
      if (!found.value) return "This app is not available at this address.";
      switch (session.tenant?.status) {
        case "DISABLED":
          return "This app has been temporarily disabled.";
        case "PROVISIONING":
          return "This app is still being set up — check back shortly.";
        case "FAILED":
        case "DRAFT":
        case "DEPROVISIONING":
        case "DELETED":
        default:
          return "This app is not available right now.";
      }
    });
    return { tenantName, logoUrl, message };
  },
});
</script>

<style scoped>
.standalone-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.standalone-auth__card {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}
.standalone-auth__title {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}
.standalone-auth__message {
  font-size: 14px;
  opacity: 0.8;
  margin: 0;
}
</style>
